import { ApiCall } from '../apiCall';
import { MediaDevice } from 'core/models/mediaDevice';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';

export type MediaDeviceListResponse = {
    devices: {
        id: string;
        project_id: string;
        type: string;
        tag?: string; // TODO: remove optional when this field be turned into permanent
        position: string;
    }[];
}

export type UnsupportedEndpoint = {
    type: undefined; // just a placeholder for discriminative union
    uri: string;
}

export type SoraEndpoint = {
    type: 'SORA';
    uri: string;
    sora_metadata: {
        channel_id: string;
        token: string;
        token_expires_at: string;
    };
}

export type JanusVideoRoomPluginMetadata = {
    plugin: 'videoroom';
    videoroom: {
        room: string;
        username: string;
    };
}

export type JanusEndpoint = {
    type: 'JANUS';
    uri: string;
    janus_metadata: JanusVideoRoomPluginMetadata & {
        iceServers?: { urls: string }[];
    };
}

export interface MediaDeviceEndpointResponse {
    endpoint: SoraEndpoint | JanusEndpoint | UnsupportedEndpoint;
}

export type MediaDeviceConfig = {
    'no_audio'?: boolean;
    'audio_bitrate'?: number;
    'audio_codec'?: string;
    'no_video'?: boolean;
    'video_bitrate'?: number;
    'min_video_bitrate'?: number;
    'video_codec'?: string;
    'video_framerate'?: number;
    'video_resolution'?: string;
}

export type GetMediaDeviceConfigResponse = {
    config: MediaDeviceConfig;
}

export async function getMediaDeviceConfig(apiCall: ApiCall, mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id) {
    return apiCall<GetMediaDeviceConfigResponse>(`/v1/projects/${projectId}/environments/${environmentId}/devices/${mediaDeviceId}/config`, {
        method: 'GET',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
    });
}

export type PutMediaDeviceConfigResponse = {
}

export async function putMediaDeviceConfig(apiCall: ApiCall, mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id, config: MediaDeviceConfig) {
    return apiCall<PutMediaDeviceConfigResponse>(`/v1/projects/${projectId}/environments/${environmentId}/devices/${mediaDeviceId}/config`, {
        method: 'PUT',
        body: JSON.stringify(config),
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
    });
}

export type PatchMediaDeviceConfigResponse = {
}

export async function patchMediaDeviceConfig(apiCall: ApiCall, mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id, config: MediaDeviceConfig) {
    return apiCall<PutMediaDeviceConfigResponse>(`/v1/projects/${projectId}/environments/${environmentId}/devices/${mediaDeviceId}/config`, {
        method: 'PATCH',
        body: JSON.stringify(config),
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' }
    });
}
